var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Tanzania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00c853",
    d: "M24,4C12.954,4,4,12.954,4,24c0,1.523,0.185,3,0.508,4.425L34.93,7.262C31.787,5.206,28.036,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M24,44c11.046,0,20-8.954,20-20c0-1.523-0.185-3-0.508-4.425L13.07,40.738 C16.213,42.794,19.964,44,24,44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffea00",
    d: "M34.93,7.262L4.508,28.425c0.213,0.94,0.496,1.852,0.836,2.737l31.857-22.16 C36.485,8.372,35.731,7.787,34.93,7.262z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffea00",
    d: "M10.799,38.998c0.716,0.631,1.47,1.216,2.271,1.74l30.422-21.163 c-0.213-0.94-0.496-1.852-0.836-2.737L10.799,38.998z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M37.201,9.002L5.344,31.162c1.169,3.041,3.053,5.719,5.455,7.835l31.857-22.16 C41.487,13.796,39.603,11.118,37.201,9.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tanzania);
export default __webpack_public_path__ + "static/media/icons8-tanzania.6c02cb313b7ea8d07ea41614e1c9fd5b.svg";
export { ForwardRef as ReactComponent };